import React, { Fragment, useEffect, useRef, useState } from "react";
// import { withRouter } from "react-router-dom";
import { bool } from "prop-types";
import { connect, useDispatch } from "react-redux";
import gaEventTracker, { events } from "util/gaEventTracker";
import CustomData from "pages/_components/CustomData/CustomData";
import Image from "pages/_components/Image";
import * as configUtils from "util/config";
import Button from "pages/_components/Button";
import { push } from "connected-react-router";
import MainContainer from "pages/_components/MainContainer";
import * as i18nUtils from "util/i18n";
import HeaderSimple from "pages/_components/HeaderSimple/HeaderSimple";
import { selectors as environmentSelectors, actions as environmentActions } from "reducers/environment";
import { Col, Row } from "react-bootstrap";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Notification from "pages/_components/Notification";
import EnvironmentStepper from "../_components/EnvironmentStepper";
import { actions as onboardingActions, selectors as onboardingSelectors } from "../../../reducers/onboarding";
import {
    defaultTextCheckboxTermsAndConditionsPJ,
    TERMS_AND_CONDITIONS_CATEGORY_PJ,
    keyErrorMessageTermsAndConditions,
    defaultErrorMessageTermsAndConditions,
} from "../../../util/onboarding";
import Checkbox from "../../_components/Checkbox";
import CustomText from "../../_components/CustomText/CustomText";

const checkboxContainerStyle = {
    display: "flex",
    flexDirection: "row",
    verticalAlign: "middle",
};
const checkboxLabelStyle = {
    paddingLeft: "0%",
    paddingTop: "0%",
    textAlign: "left",
    textJustify: "interWord",
};

const FORM_ID = "onboarding.step.stepFinish.pj";

const StepFinish = ({ isMobile, acceptTermsAndConditionsPJ, isPaywayAccepted, areTyCAccepted, fetching }) => {
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const [acceptTermsAndConditions, setAcceptTermsAndConditions] = useState(acceptTermsAndConditionsPJ);
    const [enabledPayway, setEnabledPayway] = useState(false);

    useEffect(() => {
        dispatch(environmentActions.restartEnvironmentStore());

        const paywayEnabled = configUtils.get("onboarding.payway.enable", false);
        setEnabledPayway(paywayEnabled);

        if (paywayEnabled) {
            dispatch(environmentActions.verifyPaywayAcceptance());
            dispatch(environmentActions.verifyTyCAcceptance());
        }
    }, []);

    const handleAcceptTermsAndConditions = () => {
        dispatch(onboardingActions.acceptTermsAndConditionsFinishStepPJ(TERMS_AND_CONDITIONS_CATEGORY_PJ));
    };

    const initialValuesForm = {
        termsConditions: acceptTermsAndConditionsPJ,
    };

    const onChangeCheckboxTermsAndConditions = () => {
        setAcceptTermsAndConditions(!acceptTermsAndConditions);
        dispatch(onboardingActions.acceptTermsAndConditionsPF(!acceptTermsAndConditions));
    };

    const handleOnclickTermsAndConditions = () => {
        dispatch(push("/environment/stepFinish/termsAndConditionsPJ"));
    };

    const formikProps = {
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema: () =>
            Yup.lazy(() =>
                Yup.object().shape({
                    termsConditions:
                        !enabledPayway || !areTyCAccepted
                            ? Yup.boolean(
                                  i18nUtils.get(
                                      keyErrorMessageTermsAndConditions,
                                      defaultErrorMessageTermsAndConditions,
                                  ),
                              )
                                  .required(defaultErrorMessageTermsAndConditions)
                                  .oneOf([true], defaultErrorMessageTermsAndConditions)
                            : Yup.boolean(
                                  i18nUtils.get(
                                      keyErrorMessageTermsAndConditions,
                                      defaultErrorMessageTermsAndConditions,
                                  ),
                              ).notRequired(),
                }),
            ),
        onSubmit: () => {
            handleAcceptTermsAndConditions();
        },
    };

    const titleI18n = isPaywayAccepted === false ? "onboarding.pj.stepFinish.title.1" : "onboarding.pj.stepFinish.title.continue";
    const defaultTitleText = isPaywayAccepted === false ? "¡Ya terminamos!" : "¡Ya casi terminamos!";

    return (
        <Fragment>
            <HeaderSimple className="d-flex justify-content-between" inverse showNotifications />
            <Notification scopeToShow="environment" />
            <MainContainer className="onboarding">
                <EnvironmentStepper isMobile={isMobile} page="StepFinish" />

                <Formik {...formikProps} ref={formRef} initialValues={initialValuesForm}>
                    {() => (
                        <Form className="above-the-fold" ref={formRef}>
                            <div className="step-container">
                                {!enabledPayway ? (
                                    <>
                                        <h1 className="text-center">{i18nUtils.get("", "¡Terminamos!")}</h1>
                                        <h2 className="text-center">
                                            {i18nUtils.get("", "Completaste todos los pasos")}
                                        </h2>
                                    </>
                                ) : (
                                    <>
                                        <h1 className="text-center">
                                            {i18nUtils.get(titleI18n, defaultTitleText)}
                                        </h1>
                                        <h2 className="text-center">
                                            {i18nUtils.get(
                                                "onboarding.pj.stepFinish.title.2",
                                                "Estamos validando tu información",
                                            )}
                                        </h2>
                                    </>
                                )}
                                <div className="illustration-alta-persona flex justify-center mb-8">
                                    <Image src="images/figma/illustrations/onboarding9.svg" className="svg-image" />
                                </div>
                                <div className="box box-border-soft">
                                    <p>
                                        {i18nUtils.get(
                                            "onboarding.step.stepFinish.text.1",
                                            // eslint-disable-next-line max-len
                                            "Los datos y documentación van a ser analizados y en las próximas 48 hs. un Ejecutivo va a comunicarse con vos.",
                                        )}
                                    </p>
                                    <p>
                                        {i18nUtils.get(
                                            "onboarding.step.stepFinish.text.2",
                                            // eslint-disable-next-line max-len
                                            "Asimismo, se enviará un email de invitación a las personas declaradas como firmantes.",
                                        )}
                                    </p>
                                </div>

                                <div className="container--alert" role="alert">
                                    <div className="alert alert-info">
                                        <CustomData
                                            icon="information_fill.svg"
                                            titleText={i18nUtils.get(
                                                "onboarding.step.stepFinish.legal",
                                                // eslint-disable-next-line max-len
                                                "Recordá tener en tu poder los originales o copia certificada de la documentación.",
                                            )}
                                            keepSpaceIfNoValue={false}
                                        />
                                    </div>
                                </div>

                                {!areTyCAccepted && !fetching && (
                                    <div style={checkboxContainerStyle}>
                                        <Field
                                            component={Checkbox}
                                            idForm={FORM_ID}
                                            name="termsConditions"
                                            hideLabel
                                            onChange={() => onChangeCheckboxTermsAndConditions()}
                                        />
                                        <Button
                                            style={checkboxLabelStyle}
                                            className="btn-link"
                                            block={false}
                                            onClick={() => handleOnclickTermsAndConditions()}>
                                            <CustomText
                                                text={i18nUtils.get(
                                                    "onboarding.vu.terms.and.conditions.pj.label",
                                                    defaultTextCheckboxTermsAndConditionsPJ,
                                                )}
                                            />
                                        </Button>
                                    </div>
                                )}

                                <Row className="form-actions no-print">
                                    <Col xs={12} md={4} mdOffset={4}>
                                        <Button
                                            bsStyle="primary"
                                            label={
                                                !enabledPayway || isPaywayAccepted === false
                                                    ? "global.finalize"
                                                    : "global.continue"
                                            }
                                            loading={fetching}
                                            block
                                            type="submit"
                                            disabled={!areTyCAccepted ? !acceptTermsAndConditions : false}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </Fragment>
    );
};

StepFinish.propTypes = {
    fetching: bool.isRequired,
    isMobile: bool.isRequired,
    acceptTermsAndConditionsPJ: bool.isRequired,
    isPaywayAccepted: bool.isRequired,
    areTyCAccepted: bool.isRequired,
};
const mapStateToProps = (state) => ({
    fetching: environmentSelectors.getFetching(state),
    acceptTermsAndConditionsPJ: onboardingSelectors.getAcceptTermConditionsPJ(state),
    idEnvironment: onboardingSelectors.getIdEnvironment(state),
    isPaywayAccepted: environmentSelectors.getIsPaywayAccepted(state),
    areTyCAccepted: environmentSelectors.getAreTyCAccepted(state),
});

export default connect(mapStateToProps)(StepFinish);
